import React, { Component } from "react";
import WinerySampleComponent from './components/WinerySampleComponent';
import PropTypes from 'prop-types';
import CssBaseline from '@mui/material/CssBaseline';
import { createTheme, ThemeProvider } from '@mui/material/styles';


const theme = createTheme({
  palette: {
      mode: 'light',
      primary: {
        dark:'#492335',
        main: '#69334C',
        lght:'#e496b3'
      },
      secondary: {
        dark:'#354923',
        main: '#4c6933',
        light: '#bed58e'
      },
      info:{
        main:'#695033',
        light:'#bdab99',
        dark:'#493823'
      },
     
 
    },
    
});

export class WinerySampleContainer extends Component {
    constructor (props){
        super(props)
        this.state = {

        }

    }
    



    render(){
        return(
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <WinerySampleComponent tab={this.props.tab} updateTab={this.props.updateTab}/>
          </ThemeProvider>
        );
        
    }
          
        
}

WinerySampleContainer.defaultProps={

}
WinerySampleContainer.propTypes = {
    tab: PropTypes.string,
    updateTab:PropTypes.func,
}

export default(WinerySampleContainer);